module.exports={"wireguard adapter settings":"Adapterinstellingen voor wireguard",option1:"Optie 1",option2:"Optie 2"};